import { render, staticRenderFns } from "./TpmAnalyticsTrends.vue?vue&type=template&id=05cd45aa"
import script from "./TpmAnalyticsTrends.vue?vue&type=script&lang=ts"
export * from "./TpmAnalyticsTrends.vue?vue&type=script&lang=ts"
import style0 from "./TpmAnalyticsTrends.vue?vue&type=style&index=0&id=05cd45aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports